import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // ⬅️ add useLocation
import "./NavBar.css";
import { getStoredData } from "../../api/fetchData.jsx";
import MobileNavBar from "./MobileNavBar";
import { useMediaQuery } from "react-responsive";

const Navbar = () => {
  const [navData, setNavData] = useState([]);
  const [logo, setLogo] = useState("");
  const [username, setUsername] = useState("");

  const [sidebarWidth, setSidebarWidth] = useState(() => {
    return parseInt(localStorage.getItem("sidebarWidth")) || 220;
  });

  const isCompact = sidebarWidth <= 140;
  const [isResizing, setIsResizing] = useState(false);

  const navigate = useNavigate();
  const location = useLocation(); // ⬅️ current route
  const isMobile = useMediaQuery({ maxWidth: 786 });
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);





  useEffect(() => {
    try {
      const stored = getStoredData();
      const config = stored[0];

      if (config?.page === "navbar") {
        setNavData(config.menu || []);
        setLogo(config.CompanyLogo || "");
      }

      const user = JSON.parse(localStorage.getItem("userDetails"));
      setUsername(user?.name || "Guest");
    } catch (err) {
      console.error("Navbar load error:", err);
    }
  }, []);

  const startResize = () => setIsResizing(true);
  const stopResize = () => setIsResizing(false);

  const resize = (e) => {
    if (!isResizing) return;
    const newWidth = Math.min(Math.max(e.clientX, 80), 230);
    setSidebarWidth(newWidth);
    localStorage.setItem("sidebarWidth", newWidth);
  };

  useEffect(() => {
    window.addEventListener("mousemove", resize);
    window.addEventListener("mouseup", stopResize);
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResize);
    };
  }, [isResizing]);

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
    setTimeout(() => window.location.reload(), 150);
  };

  const goToProfile = () => navigate("/profile");

  const actionMap = {
    logout: logout,
    profile: goToProfile,
  };

  const handleMenuClick = (item) => {
    if (item.onClick && actionMap[item.onClick])
      return actionMap[item.onClick]();

    if (item.link?.startsWith("http")) return window.open(item.link, "_blank");

    if (item.link) navigate(item.link);
  };

if (!hydrated) return null;

if (isMobile) {
  return (
    <MobileNavBar
      navData={navData}
      logo={logo}
      username={username}
      onLogout={logout}
      onProfile={goToProfile}
    />
  );
}


  return (
    <div
      className={`sidebar ${isCompact ? "compact" : ""}`}
      style={{ width: sidebarWidth }}
    >
      {logo && <img src={logo} alt="Logo" className="navbar-logo" />}

      <div className="sidebar-scroll">
        <ul className="sidebar-menu">
          {navData.map((item, idx) => {
            const isActive =
              item.link &&
              (location.pathname === item.link ||
                (item.link !== "/" &&
                  item.link !== "/home" &&
                  location.pathname.startsWith(item.link)));

            return (
              <li key={idx} onClick={() => handleMenuClick(item)}>
                <div className={`sidebar-item ${isActive ? "active" : ""}`}>
                  {item.icon?.startsWith("fa-") ? (
                    <i className={`fas ${item.icon} menu-icon`}></i>
                  ) : (
                    <img src={item.icon} alt="" className="menu-icon" />
                  )}
                  <span className="menu-text">{item.name}</span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="resize-handle" onMouseDown={startResize}></div>
    </div>
    
  );
};

export default Navbar;
